import { useLazyGetSpeakersQuery } from "../../utils/getSpeakers";
import TooltipV2 from "../../components/atoms/tooltip";
import { Tooltip } from "@mui/material";
import { useEffect } from "react";

interface Props {
  ids?: Array<string>;
  view?: string;
  externalSpeakers?: any;
  type?: string;
  truncate?: number | string;
  circleSize?: string;
}
export function UtilitySpeakers({
  ids,
  view = "circular",
  externalSpeakers,
  type = "",
  truncate = "",
  circleSize
}: Props) {
  const [getSpeakers, { isUser, data: users }] = useLazyGetSpeakersQuery<any>();

  const getUsers = () => {
    if (ids && ids.length > 0) {
      getSpeakers({
        pageNumber: 1,
        pageSize: ids && ids.length > 0 ? ids.length : 1,
        sortKey: "createdat",
        sortOrder: "DESC",
        data: ids ?? []
      }).unwrap();
    }
  };

  useEffect(() => {
    getUsers();
  }, [ids]);
  return (
    <div className="isolate flex -space-x-1 ">
      {users?.data?.profiles
        ?.slice(0, truncate ? truncate : users?.data?.profiles.length)
        .map((item: any, index: number) => {
          return (
            <>
              {view == "circular" &&
                (type == "card" ? (
                  <div className="">
                    <Tooltip title={item?.name?.fullName} placement="bottom">
                      <span
                        className={`relative z-${
                          (users?.data?.profiles.length - index) * 10
                        } flex ${circleSize} h-6 w-6 scale-90 text-xs rounded-full ring-2 ring-white dark:ring-border text-center text-white justify-center items-center bg-gray-500 dark:bg-gray-800`}
                      >
                        <span className="leading-none dark:text-white">
                          {item?.name?.firstName?.slice(0, 1) +
                            item?.name?.lastName?.slice(0, 1)}
                        </span>
                      </span>
                    </Tooltip>
                    {truncate &&
                      index == Number(truncate) - 1 &&
                      users?.data?.profiles.length - Number(truncate) > 0 && (
                        <span
                          className={`relative flex ${circleSize} h-6 w-6 text-xs rounded-full ring-2 ring-white dark:ring-border text-center text-white justify-center items-center bg-gray-500 dark:bg-gray-800`}
                        >
                          <span className="font-medium text-base">
                            +{users?.data?.profiles.length - Number(truncate)}
                          </span>
                        </span>
                      )}
                  </div>
                ) : (
                  <>
                    <TooltipV2
                      message={` ${item?.name?.fullName}`}
                      position="top-6  w-[max-content] mt-3 ms-2 px-3"
                    >
                      <span
                        className={`relative z-${
                          (users?.data?.profiles.length - index) * 10
                        } flex ${circleSize} h-8 w-8 rounded-full ring-2 ring-white dark:ring-border text-center text-white  justify-center items-center bg-gray-500 dark:bg-gray-800 `}
                      >
                        <span className="leading-none dark:text-white">
                          {item?.name?.firstName?.slice(0, 1) +
                            item?.name?.lastName?.slice(0, 1)}
                        </span>
                      </span>
                    </TooltipV2>
                    {truncate &&
                      index == Number(truncate) - 1 &&
                      users?.data?.profiles.length - Number(truncate) > 0 && (
                        <span
                          className={`relative flex ${circleSize} h-6 w-6 text-xs rounded-full ring-2 ring-white dark:ring-border text-center text-white justify-center items-center bg-gray-500 dark:bg-gray-800`}
                        >
                          <span className="font-medium text-base">
                            +{users?.data?.profiles.length - Number(truncate)}
                          </span>
                        </span>
                      )}
                  </>
                ))}

              {view == "normal" && (
                <span className="truncate dark:text-white">
                  {item?.name?.fullName}
                </span>
              )}
              {view == "rectangle" && (
                <div className="flex space-x-2 px-1.5 py-1 border-2 border-solid rounded-full	scale-100">
                  <TooltipV2
                    message={` ${item?.name?.fullName}`}
                    position=" w-[max-content] mt-3 ms-2 px-3"
                  >
                    <span
                      className={`relative z-${
                        (users?.data?.profiles.length - index) * 10
                      } flex h-8 w-8 rounded-full ring-2 ring-white dark:ring-border text-center text-white  justify-center items-center   bg-gray-500 dark:bg-gray-800 `}
                    >
                      <span className="leading-none dark:text-white">
                        {item?.name?.firstName?.slice(0, 1) +
                          item?.name?.lastName?.slice(0, 1)}
                      </span>
                    </span>
                  </TooltipV2>
                  <span className="pt-1 dark:text-white">
                    {item?.name?.firstName}
                  </span>
                </div>
              )}
            </>
          );
        })}
      {externalSpeakers
        ?.slice(0, truncate ? truncate : externalSpeakers?.length)
        .map((item: any, index: number) => {
          return (
            <>
              {view == "circular" &&
                (type == "card" ? (
                  <div className="">
                    <Tooltip title={item?.fullName} placement="bottom">
                      <span
                        className={`relative z-${
                          (users?.data?.profiles.length - index) * 10
                        } flex ${circleSize} h-6 w-6 scale-90 text-xs rounded-full ring-2 ring-white dark:ring-border text-center text-white justify-center items-center bg-gray-500 dark:bg-gray-800`}
                      >
                        <span className="leading-none dark:text-white">
                          {item?.firstName?.slice(0, 1) +
                            item?.lastName?.slice(0, 1)}
                        </span>
                      </span>
                    </Tooltip>
                    {truncate &&
                      index == Number(truncate) - 1 &&
                      externalSpeakers?.length - Number(truncate) > 0 && (
                        <span
                          className={`relative flex ${circleSize} h-6 w-6 text-xs rounded-full ring-2 ring-white dark:ring-border text-center text-white justify-center items-center bg-gray-500 dark:bg-gray-800`}
                        >
                          <span className="font-medium text-base">
                            +{externalSpeakers?.length - Number(truncate)}
                          </span>
                        </span>
                      )}
                  </div>
                ) : (
                  <>
                    <TooltipV2
                      message={` ${item?.fullName}`}
                      position="top-6 w-[max-content] mt-3 ms-2 px-3"
                    >
                      <span
                        className={`relative z-${
                          (users?.data?.profiles.length - index) * 10
                        } flex ${circleSize} h-8 w-8 rounded-full ring-2 ring-white dark:ring-border text-center text-white  justify-center items-center   bg-gray-500 dark:bg-gray-800`}
                      >
                        <span className="leading-none dark:text-white">
                          {item?.firstName?.charAt(0).toUpperCase() +
                            item?.lastName?.charAt(0).toUpperCase()}{" "}
                        </span>
                      </span>
                    </TooltipV2>
                    {truncate &&
                      index == Number(truncate) - 1 &&
                      externalSpeakers?.length - Number(truncate) > 0 && (
                        <span
                          className={`relative flex ${circleSize} h-6 w-6 text-xs rounded-full ring-2 ring-white dark:ring-border text-center text-white justify-center items-center bg-gray-500 dark:bg-gray-800`}
                        >
                          <span className="font-medium text-base">
                            +{externalSpeakers?.length - Number(truncate)}
                          </span>
                        </span>
                      )}
                  </>
                ))}

              {view == "normal" && (
                <span className="truncate dark:text-white">
                  {" "}
                  {item?.fullName}
                </span>
              )}
              {view == "rectangle" && (
                <div className="flex space-x-2 px-1.5 py-1 border-2 border-solid rounded-full	scale-100">
                  <TooltipV2
                    message={` ${item?.fullName}`}
                    position=" w-[max-content] mt-3 ms-2 px-3"
                  >
                    <span
                      className={`relative z-${
                        (users?.data?.profiles.length - index) * 10
                      } flex h-8 w-8 rounded-full ring-2 ring-white dark:ring-border text-center text-white  justify-center items-center   bg-gray-500 dark:bg-gray-800 `}
                    >
                      <span className="leading-none dark:text-white">
                        {item?.firstName?.charAt(0).toUpperCase() +
                          item?.lastName?.charAt(0).toUpperCase()}
                      </span>
                    </span>
                  </TooltipV2>
                  <span className="pt-1">{item?.firstName}</span>
                </div>
              )}
            </>
          );
        })}
    </div>
  );
}
